import { AnyAction, Dispatch } from 'redux';
import { WsSubscriptionData } from '../../../../store/reducers/global.reducer';
import { selectAllActiveSubscriptions } from '../../../../store/selectors/global.selector';
import { AppState } from '../../../../store/store';
import { ThunkResult } from '../ThunkResult';

export const resubscribeToActiveSubscription = (): ThunkResult<void> => {
  return async (dispatch: Dispatch<AnyAction>, getState: () => AppState) => {
    const subscriptions = selectAllActiveSubscriptions(getState());
    console.log('Resubscribing!', subscriptions);
    if (subscriptions.length > 0) {
      subscriptions?.forEach((subData: WsSubscriptionData) => dispatch(subData.resubscribeAction));
    }
  };
};
